// extracted by mini-css-extract-plugin
export default {"divContainer":"style_divContainer__vcoP9","txtContainer":"style_txtContainer__kvcFt","imgContainer":"style_imgContainer__PNDhi"};